import qs from 'simple-query-string';

import mnb, { isInNEMusic } from './mnb';

const platform = /android/i.test(window.navigator.userAgent) ? 'android' : 'ios';

const isOnScreen = (element) => {
    const screenRect = {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth,
    };
    const elementRect = element.getBoundingClientRect();

    // 如果元素的下边在显示区域之上, 则表示不在显示区域之内
    if (elementRect.bottom < 0) {
        return false;
    }

    // 如果元素的左边在显示区域之右, 则表示不在显示区域之内
    if (elementRect.left > screenRect.width) {
        return false;
    }

    // 如果元素的上边在显示区域之下, 则表示不在显示区域之内
    if (elementRect.top > screenRect.height) {
        return false;
    }

    // 如果元素的右边在显示区域之左, 则表示不在显示区域之内
    if (elementRect.right < 0) {
        return false;
    }

    return true;
};

const screenRect = {
    height: document.documentElement.clientHeight,
    width: document.documentElement.clientWidth,
};

const hasScrolled = (element, distance) => {
    const elementRect = element.getBoundingClientRect();
    return !(elementRect.top > screenRect.height + distance);
};

const getStringLen = (str) => {
    let result = 0;
    Array.from(str || '').forEach((s) => {
        result += /[\u4e00-\u9fa5]/g.test(s) ? 2 : 1;
    });
    return result;
};

const goOrpheus = (url) => {
    mnb.open({ url });
};

// FIXME: 判断方式不够严谨
const isCDN = (url) => url && /126\.net/.test(url);
const isGif = (url) => /\.(gif)/.test(url);

const imgOpt = (url, width, height, isCrop) => {
    if (isGif(url)) return url;
    const dpr = window.devicePixelRatio || 2;
    const isAndroid = /android/i.test(window.navigator.userAgent);
    const params = {
        imageView: null,
        interlace: 1,
        quality: 75,
    };
    if (isAndroid) {
        params.type = 'webp';
    }
    if (width || height) {
        params.thumbnail = `${Math.ceil(dpr * (width || 0))}${isCrop ? 'y' : 'x'}${Math.ceil(dpr * (height || 0))}`;
    }
    if (isCDN(url)) return `${url}?${qs.stringify(params)}`;
    return url;
};

const deepEqual = (x, y) => {
    if ((x && !y) || (!x && y)) return false;
    if (!x && !y) return true;
    return JSON.stringify(x) === JSON.stringify(y);
};

/*
    处理数字的显示 10万，1亿
    小于10w显示确数；
    大于等于10w小于1亿显示x.x万，如果小数点后为0，则直接显示整数；
    大于等于1亿显示x.x亿，如果小数点后为0，则直接显示整数。
*/
const getCount = function getCount(count = 0) {
    if (count >= 100000000) {
        return `${Math.floor(count / 10000000) / 10}亿`;
    } if (count >= 100000) {
        return `${Math.floor(count / 1000) / 10}万`;
    }

    return count;
};

const openUrl = (url, history, search = '', basename = '') => {
    const fullUrl = `${basename}${url}${search}`;
    if (isInNEMusic()) {
        const origin = window.location.origin || 'https://music.163.com';
        mnb.open({ url: /^https?:\/\//.test(fullUrl) ? fullUrl : `${origin}${fullUrl}` });
    } else if (history) {
        history.push({ pathname: url, search });
    } else {
        window.location.href = fullUrl;
    }
};

// Ref: https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
const retry = (fn, retriesLeft = 5, interval = 1000) => new Promise((resolve, reject) => {
    fn()
        .then(resolve)
        .catch((error) => {
            setTimeout(() => {
                if (retriesLeft === 1) {
                    // reject('maximum retries exceeded');
                    reject(error);
                    return;
                }

                // Passing on "reject" is the important part
                retry(fn, retriesLeft - 1, interval).then(resolve, reject);
            }, interval);
        });
});

const getDuration = (url) => new Promise((resolve) => {
    const curTime = +new Date();
    const videoNode = document.createElement('video');
    let src = url;
    if (typeof url === 'object') {
        src = url.resourceUrl;
    }
    videoNode.src = src;
    const timer = setInterval(() => {
        // 超过3秒返回
        if (+new Date() - curTime > 3000) {
            clearInterval(timer);
            resolve(0);
        }
        if (videoNode.readyState > 0) {
            clearInterval(timer);
            resolve(videoNode.duration);
        }
    }, 400);
});

export {
    platform,
    isOnScreen,
    hasScrolled,
    getStringLen,
    goOrpheus,
    isCDN,
    imgOpt,
    deepEqual,
    getCount,
    openUrl,
    retry,
    getDuration,
};
